import React, { useState, useEffect } from 'react';
import { loadClubRegistNumber, updateClubRegistNumber } from '../../lib/api/clubs';
import SettingCard, { SettingInfoBox, SettingInfoLabel, SettingInfoValue, CardFooter, SaveButton } from './SettingCard';

const AdminClubRegistNumberInfo = ({
    selectClubInfo,
    selectClub,
    socketKey,
    onSuccess,
}) => {
    const [registNumber, setRegistNumber] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        if (!selectClub || selectClub === 0 || !socketKey) return;

        const load = async () => {
            setIsLoading(true);
            try {
                const res = await loadClubRegistNumber({
                    clubID: selectClub,
                    socketKey,
                });
                if (res && res.data && res.data.result === 1) {
                    setRegistNumber(String(res.data.registNumber || ''));
                } else {
                    setRegistNumber('');
                }
            } catch (e) {
                console.error('클럽 등록번호 로드 실패:', e);
                setRegistNumber('');
            } finally {
                setIsLoading(false);
            }
        };
        load();
    }, [selectClub, socketKey]);

    const handleChange = (e) => {
        setRegistNumber(e.target.value);
    };

    const handleSave = async () => {
        if (!selectClub || selectClub === 0 || !socketKey) return;

        setIsSaving(true);
        try {
            const res = await updateClubRegistNumber({
                clubID: selectClub,
                registNumber: registNumber.trim(),
                socketKey,
            });
            if (res && res.data && res.data.result === 1) {
                alert('클럽 등록번호가 수정되었습니다.');
                onSuccess && onSuccess();
            } else {
                alert('클럽 등록번호 수정에 실패하였습니다.');
            }
        } catch (e) {
            console.error('클럽 등록번호 수정 실패:', e);
            alert('클럽 등록번호 수정 중 오류가 발생했습니다.');
        } finally {
            setIsSaving(false);
        }
    };

    if (!selectClubInfo) return null;

    return (
        <SettingCard title="클럽 등록번호 수정">
            <SettingInfoBox>
                <SettingInfoLabel>등록번호</SettingInfoLabel>
                <SettingInfoValue>
                    <input
                        type="text"
                        value={registNumber}
                        onChange={handleChange}
                        placeholder="클럽 등록번호를 입력하세요"
                        disabled={isLoading}
                        style={{
                            width: '100%',
                            padding: '10px 12px',
                            fontSize: '1rem',
                            color: '#555',
                            border: '1px solid #CDD9ED',
                            borderRadius: '6px',
                            outline: 'none',
                            boxSizing: 'border-box',
                            transition: 'border-color 0.15s ease',
                        }}
                    />
                </SettingInfoValue>
            </SettingInfoBox>
            <CardFooter>
                <SaveButton
                    active={true}
                    disabled={isLoading || isSaving}
                    onClick={handleSave}
                >
                    {isSaving ? '저장 중...' : '수정하기'}
                </SaveButton>
            </CardFooter>
        </SettingCard>
    );
};

export default React.memo(AdminClubRegistNumberInfo);
